import dynamic from 'next/dynamic';
import { ShareBySMSProps } from './ShareBySMS.types';

export const ShareBySMSMGP = dynamic<ShareBySMSProps>(() => import(/* webpackPrefetch: true */ './ShareBySms'));
